import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';






const ContactUsPage = () => {
  const socialMediaData = [
    {
      platform: 'Instagram',
      handle: '@your_instagram_handle',
      link: 'https://www.instagram.com/your_instagram_handle/',
      icon: <InstagramIcon fontSize="large" />,
      text: 'Follow us for daily inspiration and updates!',
    },
    {
      platform: 'Facebook',
      handle: 'Your Facebook Page',
      link: 'https://www.facebook.com/your_facebook_page',
      icon: <FacebookIcon fontSize="large" />,
      text: 'Like our page and join our community discussions!',
    },
    {
      platform: 'Twitter',
      handle: '@your_twitter_handle',
      link: 'https://twitter.com/your_twitter_handle',
      icon: <TwitterIcon fontSize="large" />,
      text: 'Stay connected and join the conversation!',
    },
  ];

  const handleSocialMediaClick = (link) => {
    window.open(link, '_blank');
  };
 
  return (
   
    <Container maxWidth="md" style={{ marginTop: '50px', textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom style={{ color: 'goldenrod', fontFamily: 'Cinzel Decorative',fontSize:'3rem', marginBottom: '20px' }}>
        GET IN TOUCH
      </Typography>
      <Typography variant="body1" paragraph style={{ color: 'darkslategrey',fontWeight:'bold', fontFamily: 'Cinzel Decorative', marginBottom: '30px' }}>
        Connect with us on social media to stay updated and engage with our community. Feel free to reach out to us through email or phone for any inquiries.
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <IconButton
            aria-label="Instagram"
            color="primary"
            onClick={() => handleSocialMediaClick(socialMediaData[0].link)}
            style={{ backgroundColor: '#3f51b5', color: '#fff', borderRadius: '50%' }}
          >
            {socialMediaData[0].icon}
          </IconButton>
          <Typography variant="body2" style={{ marginTop: '10px', color: 'goldenrod', fontWeight:'lighter', fontFamily: 'Cinzel Decorative' }}>{socialMediaData[0].text}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <IconButton
            aria-label="Facebook"
            color="primary"
            onClick={() => handleSocialMediaClick(socialMediaData[1].link)}
            style={{ backgroundColor: '#3f51b5', color: '#fff', borderRadius: '50%' }}
          >
            {socialMediaData[1].icon}
          </IconButton>
          <Typography variant="body2" style={{ marginTop: '10px', color: 'goldenrod',fontWeight:'lighter', fontFamily: 'Cinzel Decorative' }}>{socialMediaData[1].text}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <IconButton
            aria-label="Twitter"
            color="primary"
            onClick={() => handleSocialMediaClick(socialMediaData[2].link)}
            style={{ backgroundColor: '#3f51b5', color: '#fff', borderRadius: '50%' }}
          >
            {socialMediaData[2].icon}
          </IconButton>
          <Typography variant="body2" style={{ marginTop: '10px', color: 'goldenrod', fontWeight:'lighter', fontFamily: 'Cinzel Decorative' }}>{socialMediaData[2].text}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <IconButton
            aria-label="Email"
            color="primary"
            onClick={() => window.location.href = 'mailto:info@taqwa247.com'}
            style={{ backgroundColor: '#3f51b5', color: '#fff', borderRadius: '50%' }}
          >
            <EmailIcon fontSize="large" />
          </IconButton>
          <Typography variant="body2" style={{ marginTop: '10px', color: 'goldenrod',fontWeight:'lighter', fontFamily: 'Cinzel Decorative' }}>Send us an email: info@taqwa247.com</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <IconButton
            aria-label="Phone"
            color="primary"
            onClick={() => window.location.href = 'tel:+1234567890'}
            style={{ backgroundColor: '#3f51b5', color: '#fff', borderRadius: '50%' }}
          >
            <PhoneIcon fontSize="large" />
          </IconButton>
          <Typography variant="body2" style={{ marginTop: '10px', color: 'goldenrod',fontWeight:'lighter', fontFamily: 'Cinzel Decorative' }}>Call us at: +123 456 7890</Typography>
        </Grid>
      </Grid>
    </Container>
 
  );
};

export default ContactUsPage;
